import * as Icon from "@ant-design/icons";
import { Switch, Modal, Col, Form, Row, Flex } from "antd";
import { ColumnsType } from "antd/es/table";
import Search from "antd/lib/input/Search";
import { useEffect } from "react";
import { AtivoModel } from "../../models/ativoModel";
import { TipoSorteioModel } from "../../models/tipoSorteio/tipoSorteioModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { atualizarTipoSorteioAtivo, buscarTipoSorteio, deletarTipoSorteio } from "../../services/tipoSorteioService";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import CadastroTipoSorteio from "./modals/cadastrar";
import { setBuscaTipoSorteio, setEntityTipoSorteio, setModalCadastrarTipoSorteio, setModalDeletarTipoSorteio } from "../../redux/slices/tipoSorteio/tipoSorteioSlice";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import { SwitchComponent } from "../../components/button/switch";

const TipoSorteio = () => {
  //estados globais
  const tipoSorteioState = useAppSelector((state) => state.tipoSorteio);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(tipoSorteioState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("TIPO DE SORTEIO"));
    dispatch(buscarTipoSorteio(tipoSorteioState.busca));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityTipoSorteio({}));
    dispatch(setModalCadastrarTipoSorteio(true));
  };

  const goEditar = (value: TipoSorteioModel) => {
    dispatch(setEntityTipoSorteio(value));
    dispatch(setModalCadastrarTipoSorteio(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarTipoSorteio(false));
  };

  const goDeletar = (value: TipoSorteioModel) => {
    dispatch(setEntityTipoSorteio(value));
    dispatch(setModalDeletarTipoSorteio(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarTipoSorteio(false));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaTipoSorteio(value));
    dispatch(buscarTipoSorteio(value));
  };

  const onChangeAtivo = (value: TipoSorteioModel) => {
    const args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarTipoSorteioAtivo({ value: args, busca: tipoSorteioState.busca }));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<TipoSorteioModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_, record) => <SwitchComponent onChange={() => onChangeAtivo(record)} checked={record.ativo} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar">
                <Search allowClear placeholder="Denominação" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={tipoSorteioState.list} columns={columns} loading={tipoSorteioState.loading} />
      <Modal
        title={editar ? "EDITAR TIPO DE SORTEIO" : "NOVO TIPO DE SORTEIO"}
        centered
        open={tipoSorteioState.modalCadastrar}
        closable={false}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroTipoSorteio />
      </Modal>
      <Modal title={"REMOVER TIPO DE SORTEIO"} centered width={350} open={tipoSorteioState.modalDeletar} closable={false} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o tipo de sorteio?"
          action={deletarTipoSorteio({ value: tipoSorteioState.entity.id, busca: tipoSorteioState.busca })}
          close={setModalDeletarTipoSorteio(false)}
        />
      </Modal>
    </Flex>
  );
};

export default TipoSorteio;
